import React from 'react'; // eslint-disable-line

const Derp = () => null;

export default Derp;



/** WEBPACK FOOTER **
 ** ./src/Derp.js
 **/